/* tslint:disable */
/* eslint-disable */
export enum CustomerTitleEnum {
  Mr = 'Mr',
  Mrs = 'Mrs',
  Ms = 'Ms',
  Miss = 'Miss',
  Dr = 'Dr'
}
